<template>
	<div>
		<el-dialog
			v-model="visible"
			@close="dialogClose"
			class="dialog"
			header-class="headerClass"
			body-class="bodyClass"
			:show-close="false"
			append-to-body
			width="440px"
			top="calc(50vh - (276px / 2))"
			>
			<div class="captcha-container">
				<div class="captcha-header">
					<h2>输入动态验证码</h2>
					<p class="tips">当前账号已开启MFA，请到秘钥设备中获取</p>
				</div>
			
				<div class="input-group">
					<input
						v-for="(item, index) in codeLen"
						:key="index"
						v-model="codeList[index]"
						type="text"
						class="input-item"
						:class="{ active: currentIndex === index }"
						maxlength="1"
						@input="handleInput(index, $event)"
						@focus="handleFocus(index)"
						@keyup.tab="handleTab(index)"
						@keyup.backspace="handleBackspace(index)" 
						ref="inputRefs"
					/>
				</div>
				<el-button class="confirm-btn" :disabled="!isComplete||confirmLoading" :loading="confirmLoading" @click="confirm">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref, getCurrentInstance, computed, watch, nextTick } from 'vue';
	let {proxy} = getCurrentInstance();
	let codeLen = ref(6);
	let visible = ref(false);
	let show = ()=>{
		visible.value = true;
	}
	let close = ()=>{
		visible.value = false;
		confirmLoading.value = false;
	}
	let clear = ()=>{
		codeList.value = new Array(codeLen.value).fill('');
	}
	let dialogClose = ()=>{
		visible.value = false;
		clear();
	}
	// 验证码列表
	const codeList = ref(new Array(codeLen.value).fill(''));
	const _codeList = ref(new Array(codeLen.value).fill(''));
	// 当前激活输入框索引
	const currentIndex = ref(0)
	// 输入框ref数组（用于手动聚焦）
	const inputRefs = ref([])
	
	// 判断是否输入完成
	const isComplete = computed(() => {
	return codeList.value.every(item => item !== '')
	})
	let comp_codeList = computed(()=>codeList.value.map(e=>e));
	watch(()=>comp_codeList.value,(value,oldValue)=>{
		if(currentIndex.value == codeList.value.length-1){
			_codeList.value = oldValue;
		}else{
			_codeList.value = value;
		}
	},{deep:true})
	// 输入处理
	const handleInput = (index, e) => {
		const value = e.target.value.replace(/\D/g, ''); // 只允许输入数字
		codeList.value[index] = value;
		
		// 输入后自动聚焦到下一个输入框
		if (value && index < (codeLen.value-1)) {
			currentIndex.value = index + 1;
			// 手动聚焦到下一个输入框（确保焦点生效）
			nextTick(() => {
				inputRefs.value[index + 1]?.focus();
			})
		}
	}
	
	// 聚焦处理
	const handleFocus = (index) => {
		currentIndex.value = index
	}
	
	// Tab键处理
	const handleTab = (index) => {
		// if (index < 5) {
		// 	currentIndex.value = index + 1
		// 	nextTick(() => {
		// 		inputRefs.value[index + 1]?.focus()
		// 	})
		// }
	}
	
	// 新增：回退/删除键处理（核心逻辑）
	const handleBackspace = (index) => {
		// 1. 当前输入框有内容 → 清空内容，不跳转
		if (_codeList.value[index]!=='') {
			codeList.value[index] = '';
			_codeList.value[index]='';
		} 
		// 2. 当前输入框无内容 → 跳转到上一个输入框并清空（如果有上一个）
		else if (index > 0) {
			currentIndex.value = index - 1
			codeList.value[index - 1] = '' // 清空上一个输入框内容
			_codeList.value[index - 1] = '';
			// 手动聚焦到上一个输入框
			nextTick(() => {
				inputRefs.value[index - 1]?.focus()
			})
		}
	}
	
	// 监听验证码变化，自动聚焦到第一个空输入框
	watch(codeList, () => {
		const emptyIndex = codeList.value.findIndex(item => item === '')
		if (emptyIndex !== -1) {
			currentIndex.value = emptyIndex
			// 确保焦点同步到对应输入框
			nextTick(() => {
				inputRefs.value[emptyIndex]?.focus()
			})
		}
	})
	
	// 组件挂载后，自动聚焦第一个输入框
	watch(() => inputRefs.value.length, (len) => {
		if (len === codeLen.value) {
			proxy.$nextTick(async()=>{
				await proxy.awaitTime(300);//需要避开0.3秒的动画时间
				inputRefs.value[0]?.focus();

			})
		}
	})
	const confirmLoading = ref(false);
	// 点击确认
	const confirm = ()=>{
		proxy.$emit('success',codeList.value.join(''));
	}
	
	defineExpose({
		show,
		close,
		clear,
		confirmLoading,
		visible,
	})
</script>

<style lang="scss" scoped>
	.captcha-container {
		width: 440px;
		padding: 30px;
		background: #fff;
		border-radius: 8px;
		color: #000;
		text-align: center;
	}
	
	.captcha-header h2 {
		margin: 0 0 10px;
		font-size: 20px;
		font-weight: 500;
	}
	
	.tips {
		margin: 0 0 30px;
		font-size: 12px;
		color: #999;
	}
	
	.input-group {
		display: flex;
		justify-content: center;
		gap: 12px;
		margin-bottom: 30px;
	}
	
	.input-item {
		width: 48px;
		height: 48px;
		border: 1px solid #aaa;
		background: #fff;
		color: #000;
		font-size: 20px;
		text-align: center;
		border-radius: 4px;
		outline: none;
		transition: all 0.2s;
	}
	
	.input-item.active {
		border-color: #a2d959;
		box-shadow: 0 0 4px rgba(162, 217, 89, 0.5);
	}
	
	.confirm-btn {
		width: 80%;
		height: 56px;
		border: none;
		border-radius: 28px;
		/* background: linear-gradient(to right, #a2d959, #2ecc71); */
		background: var(--qx2-primary-linearGradient-color);
		color: #fff;
		font-size: 16px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s;
		&.is-disabled{
			background: var(--qx2-primary-linearGradient-color);
			border-color:unset;
			color:#fff;
			&:hover{
				background: var(--qx2-primary-linearGradient-color);
				border-color:unset;
				color:#fff;
			}
		}
		&:hover{
			background: var(--qx2-primary-linearGradient-color);
			border-color:unset;
			color:#fff;
		}
	}
	
	.confirm-btn:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
</style>